import { Locale } from 'core/helpers/dateUtils';

/**
 * Returns the timezone formatted ISO string Date of the supplied Date
 * @param date Date to format
 * @param isEndDate Boolean to determine if the date is the end date or not
 * @returns Formatted date
 */
export const toLocaleISO = (date: Date, isEndDate?: boolean): string => {
  const dateTime = new Date(date);
  if (isEndDate) {
    dateTime.setDate(dateTime.getDate() + 1);
  }
  return Locale.toISO(dateTime);
};

/**
 * Calculate percentage change between current and previous values
 * @param current Current value
 * @param previous Previous value
 * @returns Percentage change
 */
export const calcPercentChange = (current: number, previous: number): number => {
  if (previous === 0) {
    return 0;
  }
  return parseFloat(((current / previous) * 100).toFixed(2));
};

/**
 * Calculate difference for metrics
 * @param stateObj State object
 * @param key Key to get data for
 * @returns Percentage change
 */
export const calcDiff = (stateObj: any, key: string): number => {
  if (!stateObj || !stateObj.previousDataSet || !stateObj.currentDataSet) {
    return 0;
  }

  let previousOne = (stateObj.previousDataSet as any)[key];
  if (previousOne === 0) {
    previousOne = 1;
  }

  return calcPercentChange((stateObj.currentDataSet as any)[key], previousOne);
};

/**
 * Default throttle configuration
 */
export const defaultThrottleConfig = {
  debounce_interval: 10000,
  max_wait: 10000,
};

/**
 * Convert seconds to hours
 * @param seconds Seconds to convert
 * @returns Hours
 */
export const convertSecondsToHours = (seconds: number): number => {
  return seconds / 3600;
};
